export const customerRoutes = {
  path: "/customer",
  component: () => import("@/layouts/Customer/CustomerLayout.vue"),
  children: [
    {
      path: "/customer/dashboard",
      name: "customer-dashboard",
      component: () => import("@/modules/Dashboard/views/Customer"),
      redirect: {
        name: "customer-dashboard-overview",
      },
      children: [
        {
          path: "",
          name: "customer-dashboard-overview",
          component: () =>
            import("@/modules/Dashboard/views/Customer/index.vue"),
        },
      ],
    },
  ],
};

export default {};
